import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Grid, Button, Tabs, Tab } from "@material-ui/core";
import ResetTestData from './ResetTestData';

class TestHarness extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({value});
  }

  renderTabContainer = (value) => {
    if(value === 0)
      return this.renderResetTestData();
  }

  renderResetTestData = () => {
    return (<ResetTestData/>);
  }

  render() {
    const {
  
      authentication: { user }
    } = this.props;
    const {value} = this.state;

    return (
      <Fragment>
        <Tabs value={value} onChange={this.handleChange} position="static">
        <Tab label="Reset Test Data"></Tab>        
        </Tabs>
        {this.renderTabContainer(value)}                 
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  authentication,
});

export default connect(
  mapStateToProps,
)(TestHarness);
